import { Trans } from '@lingui/macro'
import Web3Status from 'components/Web3Status'
import { Box } from 'nft/components/Box'
import { Row } from 'nft/components/Flex'
import { UniIcon } from 'nft/components/icons'
import { ReactNode } from 'react'
import { NavLink, NavLinkProps, useLocation } from 'react-router-dom'

import { ChainSelector } from './ChainSelector'
// import { MenuDropdown } from './MenuDropdown'
import * as styles from './style.css'

interface MenuItemProps {
  href: string
  id?: NavLinkProps['id']
  isActive?: boolean
  children: ReactNode
}

const MenuItem = ({ href, id, isActive, children }: MenuItemProps) => {
  return (
    <NavLink
      to={href}
      className={isActive ? styles.activeMenuItem : styles.menuItem}
      id={id}
      style={{ textDecoration: 'none' }}
    >
      {children}
    </NavLink>
  )
}

const PageTabs = () => {
  const { pathname } = useLocation()
  // const { chainId: connectedChainId } = useWeb3React()
  // const chainName = chainIdToBackendName(connectedChainId)

  const isPoolActive =
    pathname.startsWith('/pool') ||
    pathname.startsWith('/add') ||
    pathname.startsWith('/remove') ||
    pathname.startsWith('/increase') ||
    pathname.startsWith('/find')

  return (
    <>
      <MenuItem href="/swaptokens" isActive={pathname.startsWith('/swap')}>
        <Trans>Swap</Trans>
      </MenuItem>
      {/* <MenuItem href={`/tokens/${chainName.toLowerCase()}`} isActive={pathname.startsWith('/tokens')}>
        <Trans>Tokens</Trans>
      </MenuItem> */}
      <MenuItem href="/pool" id="pool-nav-link" isActive={isPoolActive}>
        <Trans>Pool</Trans>
      </MenuItem>
    </>
  )
}

const Navbar = () => {
  const { pathname } = useLocation()

  const isPoolActive =
    pathname.startsWith('/pool') ||
    pathname.startsWith('/add') ||
    pathname.startsWith('/remove') ||
    pathname.startsWith('/increase') ||
    pathname.startsWith('/find')
  return (
    <>
      <nav className={styles.nav}>
        <Box display="flex" height="full" flexWrap="nowrap" alignItems="stretch">
          <Box className={styles.leftSideContainer}>
            <Box as="a" href="#/swaptokens" className={styles.logoContainer}>
              <UniIcon width="68" height="58" viewBox="0 0 71 101" className={styles.logo} />
            </Box>
            <Box as="a" href="#/swaptokens" display={{ sm: 'none', xl: 'flex' }} className={styles.logoTextHolder}>
              <span className={styles.logoText}>GENIE</span>
              <span className={styles.logoTextBold}>SWAP</span>
            </Box>
            <Box display={{ sm: 'flex', lg: 'flex' }}>
              <ChainSelector leftAlign={true} />
            </Box>
          </Box>
          {/* <Box className={styles.middleContainer}>
            <SearchBar />
          </Box> */}
          <Box className={styles.rightSideContainer}>
            <Row gap="12">
              {/* <Box display={{ sm: 'flex', xl: 'none' }}>
                <SearchBar />
              </Box> */}
              {/*<Box display={{ sm: 'none', lg: 'flex' }}>
                <MenuDropdown />
              </Box>*/}
              {/*{!isNftPage && false && (
                <Box display={{ sm: 'none', lg: 'flex' }}>
                  <ChainSelector />
                </Box>
              )}*/}

              <Row gap="8" display={{ sm: 'none', lg: 'flex' }}>
                <PageTabs />
              </Row>

              {isPoolActive && <Web3Status />}
            </Row>
          </Box>
        </Box>
      </nav>
      <Box className={styles.mobileBottomBar}>
        <PageTabs />
        {/*<Box marginY="4">
          <MenuDropdown />
        </Box>*/}
      </Box>
    </>
  )
}

export default Navbar
